import { render } from "./FilterPills.vue?vue&type=template&id=ab60e118&scoped=true"
import script from "./FilterPills.vue?vue&type=script&lang=js"
export * from "./FilterPills.vue?vue&type=script&lang=js"

import "./FilterPills.vue?vue&type=style&index=0&id=ab60e118&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab60e118"]])

export default __exports__